import {auth0ClientProvider} from "../auth/sso";

const baseUrl = `${process.env.REACT_APP_RAGNAROK_BASE_URL}/api/v1-beta`;

async function buildReq(method = undefined, headers = undefined, body = undefined) {
    return auth0ClientProvider.getTokenSilently()
        .then((token) => {
            return {
                method,
                headers: Object.assign({
                    Authorization: `Bearer ${token}`
                }, headers),
                body
            }
        });
}

function findHubs() {
    return buildReq()
        .then((req) => {
            return fetch(`${baseUrl}/hubs`, req);
        })
        .then((res) => {
            return handleResponse(res);
        });
}

function findHubById(hubId) {
    return buildReq()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}`, req);
        })
        .then((res) => {
            return handleResponse(res);
        });
}

function findHubThings(hubId) {
    return buildReq()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/things`, req);
        })
        .then((res) => {
            return handleResponse(res);
        });
}

function updateHub(hubId, launched) {
    return buildReq(
        'PATCH',
        {'Content-Type': 'application/json'},
        JSON.stringify({launched})
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}`, req)
    }).then((res) => {
        return handleResponse(res);
    });
}

function updateHubThing(hubId,
                        thingId,
                        enabled = undefined,
                        collectionInterval = undefined,
                        actuatorConfiguration = undefined,
                        collectionConfiguration = undefined) {
    const payload = {};

    if (enabled !== undefined) payload["enabled"] = enabled;
    if (collectionInterval !== undefined) payload["collection_interval"] = collectionInterval;
    if (actuatorConfiguration !== undefined) payload["actuator_configuration"] = actuatorConfiguration;
    if (collectionConfiguration !== undefined) payload["collection_configuration"] = collectionConfiguration;

    return buildReq(
        'PATCH',
        {'Content-Type': 'application/json'},
        JSON.stringify(payload)
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}/things/${thingId}`, req);
    }).then((res) => {
        return handleResponse(res);
    });
}

function updateThing(thingId,
                     connectionProtocol = undefined,
                     connectionConfiguration = undefined) {
    const payload = {};

    if (connectionProtocol !== undefined) payload["connection_protocol"] = connectionProtocol;
    if (connectionConfiguration !== undefined) payload["connection_configuration"] = connectionConfiguration;

    return buildReq(
        'PATCH',
        {'Content-Type': 'application/json'},
        JSON.stringify(payload)
    ).then((req) => {
        return fetch(`${baseUrl}/things/${thingId}`, req)
    }).then((res) => {
        return handleResponse(res);
    });
}

function exportMetrics(hubId, from, to) {
    return buildReq()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/metrics/export?from=${from}&to=${to}`, req)
        });
}

function executeHubThingActions(hubId,
                                thingId,
                                methods) {
    const payload = {methods};

    return buildReq(
        'POST',
        {'Content-Type': 'application/json'},
        JSON.stringify(payload)
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}/things/${thingId}/actions`, req);
    }).then((res) => {
        return handleResponse(res);
    });
}

function handleResponse(res) {
    return res.ok ? res : res.json().then(json => Promise.reject(json));
}

export {
    findHubs,
    findHubById,
    findHubThings,
    updateHub,
    updateHubThing,
    updateThing,
    exportMetrics,
    executeHubThingActions
}